<template>
  <a :href="post.url" target="_blank">
    <div class="embed-responsive embed-responsive-16by9">
      <picture
        class="embed-responsive-item img-fluid"
        :style="{ backgroundImage: `url(${post.thumb_url})`}"
      ></picture>
    </div>

    <h6>{{ post.title }}</h6>
  </a>
</template>

<script>
export default {
	props: {
		post: { type: Object, required: true }
	}
}
</script>

<style lang="scss" scoped>

h6 {
	transition: all .5s;
  text-align: left;
  margin-top: 8px;
}

picture {
  background-size: cover;
  background-position: center center;
}

.embed-responsive {
  border-radius: 8px;
  border: 1px solid rgba(#000, .1);
}
</style>